var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mass-message-edit',{attrs:{"group-list":_vm.groups,"selected-group-ids":_vm.ids,"default-back":{ name: 'messages' }},on:{"save":_vm.onSave}})}
var staticRenderFns = []

export { render, staticRenderFns }